<template>
  <div>
    <!--    销售顾问列表-->
    <x-grid
        :id="'formList'"
        :rowId="rowId"
        :pager-config="pagerConfig"
        :form-config="formConfig"
        :url="url"
        :columns="columns"
        :checkbox-config="checkboxConfig"
        :toolbar-config="toolbarConfig"
        :print-config="printConfig"
        :import-config="importConfig"
        :export-config="exportConfig"
        ref="grid"
        :cellClick="chooseRow"
        :cellDbClick="updateRow"
        @toolbar-addData="addRow"
    >
      <template v-slot:[toolbarConfig.templatelSlots]>
      </template>
    </x-grid>

    <a-space class="a-form-btn-box">
      <a-button @click="closeAssignPop()">取消</a-button>
      <a-button type="primary" @click="getAssignPopResult">提交</a-button>
    </a-space>

  </div>
</template>

<script>
import {
  GridMixin,
  api,
  fac,
} from "@/utils/common/XGridBase";
import {dataApi} from '@/services/client/inherit.js';
console.log(dataApi)
//列表接口 - 带部门权限的成员列表接口
const url = api.comm.USER + '/popSelectUserList';

//主键
const rowId = 'userId';

//列
const columns = [
  fac.makeColumnRadioDefault(),
  // fac.makeColumnCheckboxDefault(),

  fac.makeColumn("userName", "姓名", 120),
  fac.makeColumn("userNo", "用户账号", 160),
  fac.makeColumn("deptName", "部门", 160),
  fac.makeColumn("mobile", "手机号", 160),
]

//筛选项
const formConfig = fac.makeFormConfig(columns, [
  {field: 'userName'},
  {field: 'mobile'},
])

//工具栏按钮
const toolbarConfig = fac.makeToolbarConfig({
  import: false,
  export: false,
  delData: false,
  addData: false,
  templatelSlots: 'toolbarBtns'
});

//可编辑表格约束
const editRules = fac.makeEditRules(columns);
const printConfig = fac.makePrintConfig(columns);
const pagerConfig = fac.makePagerConfig();
const checkboxConfig = fac.makeCheckboxConfig(columns);

async function loadBaseData() {

}

export default {
  mixins: [GridMixin],
  // props: ['assignIdArr'],
  props: {
    assignIdArr: {
      type: Array,
      default: () => []
    },
    type: {
      type: Number,
      default: 1
    }
  },
  components: {},
  data() {
    return {
      columns,
      rowId,
      url,
      formConfig,
      toolbarConfig,
      printConfig,
      checkboxConfig,
      editRules,
      pagerConfig,
    }
  },
  async mounted() {
    // let that = this;
    // setInterval(()=>{
    //   console.log(that.$refs['grid'].$refs['xGrid'].getFormItems())
    // },1000)
  },
  methods: {
    loadBaseData,
    /**
     * 提交数据 分配
     * @param entities
     * @param vm
     * @returns {Promise}
     */
    async getAssignPopResult() {
      let userId = this.$refs['grid'].$refs['xGrid'].getRadioRecord();
      if (!userId) {
        this.$message.error('请选择一条数据');
        return false;
      }
      // let result = {
      //   userId: userId.userId,
      //   idList: this.assignIdArr.join(',')
      // }
      this.loading(true);
      let entity;
      if (this.type === 1) {
        entity = await dataApi.saveAssignResult(userId.userId, this.assignIdArr);
      } else {
        entity = await dataApi.saveCustAssignResult(userId.userId, this.assignIdArr);
      }
      if (entity.code === 200) {
        this.loading(false);
        this.$emit('closeParent')
        // this.$nextTick(()=>{  //todo 保持子表显示并刷新功能
        //   this.$emit('close');
        //   this.$emit('openParent')
        // })
      }
    },
    // 取消 关闭弹窗
    closeAssignPop() {
      this.$emit('close');
    }
  }
}
</script>

<style scoped>

/deep/ .vxe-table--body-wrapper {
  height: 300px !important;
}

/deep/ .vxe-table--empty-placeholder {
  height: 300px !important;
}

</style>